class LanguageSwitcher {

	constructor() {
		this.changeLanguage();
	}

	changeLanguage() {
    ( function( $ ) {
      $('#language-switcher button.switch').on('click', function(){
        if($('#language-switcher select:not(.d-none)').find(':selected').prop('disabled')){
          $(this).closest('.cover-bg-modal').removeClass('show');
        }else{
  				$(this).addClass('loading');
          window.location = $('#language-switcher select.language-select:not(.d-none)').val();
        }
      });

      $('#language-switcher #regions').on('change', function(){
        $('.language-select').addClass('d-none');

        $('#' + $(this).val()).removeClass('d-none');
      });
		}( jQuery ) );
  }
}

export default LanguageSwitcher;
